import { useState, useEffect, useCallback } from 'react';
import { getApiUsageAnalytics } from '../services/adminService';

export const useAPIUsageAnalytics = (params) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const paramsKey = params ? JSON.stringify(params) : '';

  const fetchAnalytics = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getApiUsageAnalytics(params);
      if (res && (res.success || res.metrics)) {
        setData(res);
      }
    } catch (err) {
      console.error("Failed to fetch API usage analytics:", err);
      setError(err.message || "Failed to fetch API usage analytics");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsKey]);

  useEffect(() => {
    fetchAnalytics();
  }, [fetchAnalytics]);

  return {
    analyticsData: data,
    loading,
    error,
    refetch: fetchAnalytics
  };
};

export default useAPIUsageAnalytics;
